import { FormErrors } from 'redux-form'

import { find } from 'lodash'
import { validationRequired, validationString } from '../../../../utils/helpers'
// eslint-disable-next-line import/no-cycle
import { IRenameFolderForm } from './RenameFolderForm'

/**
 * @param {IRenameFolderForm} values
 */
export default (values: any) => {
	const errors: FormErrors<IRenameFolderForm> = {}

	const nameError = find([validationRequired(values?.name), validationString(100)(values?.name)], (err) => !!err)
	if (nameError) {
		errors.name = nameError
	}

	return errors
}
